// @flow

import Player from "@vimeo/player";
// import { pubsub } from "@utils/";
//import Component from '../classes/component';

class VideoVimeo {
    props: PropsType;
    $element: HTMLElement;
    player: any;

    constructor(props: PropsType) {
        // set props and defaults
        this.props = {
            ...props,
            dataVimeoAttribute: props.$element.getAttribute("data-id-vimeo"),
        };

        // elements
        this.$element = props.$element;

        // kick off
        this.init();
    }

    init() {
        const vimeoPlayer = this;
        this.idVideo = this.props.dataVimeoAttribute;
        this.$player = new Player(this.$element, {
            id: this.idVideo,
            quality: "1080p",
            background: false,
            loop: false,
            autoplay: false,
            autopause: false,
        });

        console.log(this.$player);

        this.$player
            .getDuration()
            .then(function(duration) {
                const min = Math.floor(duration / 60);
                // const sec = duration - min * 60;
                const timing = min + " min";

                console.log(duration, timing);

                const timestamp = vimeoPlayer.$element.getElementsByClassName(
                    "video-and-description__timestamp__text"
                )[0];

                timestamp.innerHTML = timing;
            })
            .catch(function(error) {
                // an error occurred
                console.log(error);
            });

        this.$element.addEventListener("click", e => {
            e.preventDefault();
            this.$player.play().catch(error => {
                console.log(error);
            });

            this.$element.classList.add("is-hidden");
        });
    }
}

export default VideoVimeo;
